<mat-form-field [ngStyle]="{width: '100%'}" appearance="fill">
  @if (prefixIcon) {
    <mat-icon matPrefix>{{ prefixIcon }}</mat-icon>
  }
  <mat-label>{{ placeholder }}</mat-label>
  <input type="text" [placeholder]="placeholder" matInput [formControl]="control" [matAutocomplete]="auto" [matAutocompleteDisabled]="disabled">
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption($event)">
    @for (option of options; track itemTracker($index)) {
      <mat-option
        [value]="option.value"
        >
        {{ option.label }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (prefixIcon) {
    <mat-icon matSuffix>{{ suffixIcon }}</mat-icon>
  }
</mat-form-field>
